import React, { useEffect, useRef } from "react";
import { useScroll } from "framer-motion";
function toTimecode(progress: number) {
  const totalFrames = Math.round(progress * 1440);
  const seconds = Math.floor(totalFrames / 24);
  const frames = totalFrames % 24;
  return `${String(Math.floor(seconds / 60)).padStart(2, "0")}:${String(seconds % 60).padStart(2, "0")}:${String(frames).padStart(2, "0")}`;
}

/**
 * Writes directly to the DOM on scroll instead of setting React state, so the whole tree
 * isn't re-rendered on every scroll frame.
 */
export function ScrollTimecode() {
  const {
    scrollYProgress
  } = useScroll();
  const barRef = useRef<HTMLDivElement>(null);
  const labelRef = useRef<HTMLSpanElement>(null);
  useEffect(() => {
    let lastLabel = "";
    const paint = (value: number) => {
      const clamped = Math.max(0, Math.min(1, value));
      if (barRef.current) barRef.current.style.height = `${clamped * 100}%`;
      const next = toTimecode(clamped);
      if (labelRef.current && next !== lastLabel) {
        labelRef.current.textContent = next;
        lastLabel = next;
      }
    };
    paint(scrollYProgress.get());
    return scrollYProgress.on("change", paint);
  }, [scrollYProgress]);
  return <div aria-hidden="true" className="pointer-events-none fixed right-4 top-1/2 z-40 hidden -translate-y-1/2 flex-col items-center gap-4 xl:flex" data-id="element-364" data-mp="2y73wwysf8d2q">
      <span className="font-mono text-[11px] tracking-[0.16em] text-white/45" data-id="element-365" data-mp="2u4qzqyrqpnhk">TC</span>
      <div className="relative h-40 w-px bg-white/12" data-id="element-366" data-mp="2p5e5hsyjhe4y">
        <div ref={barRef} className="absolute inset-x-0 top-0 bg-[#54f6c6]" style={{
        height: "0%"
      }} data-id="element-367" data-mp="2k7cl94pdn8rw" />
      </div>
      <span ref={labelRef} className="font-mono text-[11px] tabular-nums tracking-[0.12em] text-white/55 [writing-mode:vertical-rl]" data-id="element-368" data-mp="2fa2p767hfyv3">
        00:00:00
      </span>
    </div>;
}